<template>
  <div id="app">
    <div class="header">
      <van-nav-bar title="缴费记录" left-text="返回" @click-left="backJump" left-arrow>
        <template #right>
          <van-icon name="ellipsis" />
        </template>
      </van-nav-bar>
    </div>
    <div style="width: 90%;margin: 0 auto">
      <p style="font-family: '黑体'">消费记录</p>
      <van-cell-group v-for="item in content" style="padding-top:10px;padding-bottom: 10px">
        <van-cell v-if="item.status == 0" title="待支付" :value="'￥'+item.price" :label="item.createTime" />
        <van-cell v-else title="支付成功" :value="'￥'+item.price" :label="item.createTime" />
      </van-cell-group>
    </div>

  </div>
</template>

<script>
import {records} from "../common/api/record"
import jump from "../common/jump";

export default {
  name: "record",
  data(){
    return {
      content:[]
    }
  },
  mounted() {
    this.info()
  },
  methods:{
    info(){
      records({payType:8}).then(res => {
        console.log(res)
        this.content = res.data.items
      })
    },

    backJump(){
      this.$destroy()
      jump.$emit('back')
      this.$router.go(-1)
    },
  }
}
</script>

<style scoped>

</style>